'use es6';

import env from 'enviro';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
const add = (type, message, messageOptions = {}, ...alertOptions) => {
  if (!isValidI18nKey(message) && messageOptions._defaultMessage && isValidI18nKey(messageOptions._defaultMessage)) {
    message = messageOptions._defaultMessage;
  }
  if (isValidI18nKey(message)) {
    message = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: message,
      options: messageOptions
    });
  } else if (!env.deployed()) {
    console.warn('Alert key not translated: ', message);
    if (messageOptions._defaultMessage) {
      console.warn('Alert default key not translated: ', messageOptions._defaultMessage);
    }
  }
  FloatingAlertStore.addAlert(Object.assign({
    message,
    type
  }, ...alertOptions));
};
export const addAlert = FloatingAlertStore.addAlert;
export const addError = (...args) => add('warning', ...args);
export const addSuccess = (...args) => add('success', ...args);
export const addDanger = (...args) => add('danger', ...args);